import Components from './../Component';

export default class Timeago extends Components {

  constructor($) {
    super($);
    this.currentLanguage = $('body').attr('data-language');
    this.translation = {
      fr: {

        prefixAgo: "Il y a",
        
        seconds: "moins d'une minute",
        
        minute: "une minute",
        
        minutes: "%d minutes",
        
        hour: "une heure",
        
        hours: "%d heures",
        
        day: "un jour",
        
        days: "%d jours",
        
        month: "un mois",
        
        months: "%d mois",
        
        year: "un an",
        
        years: "%d ans"
        
        },
        
        en: {
        
        suffixAgo: "ago",
        
        seconds: "less than a minute",
        
        minute: "one minute",
        
        minutes: "%d minutes",
        
        hour: "one hour",
        
        hours: "%d hours",
        
        day: "one day",
        
        days: "%d days",
        
        month: "one month",
        
        months: "%d months",
        
        year: "one year",
        
        years: "%d years"
        
        },
        
        de: {
        
        prefixAgo: "Vor",
        
        seconds: "weniger als einer Minute",
        
        minute: "einer Minute",
        
        minutes: "%d Minuten",
        
        hour: "einer Stunde",
        
        hours: "%d Stunden",
        
        day: "einem Tag",
        
        days: "%d Tagen",
        
        month: "einem Monat",
        
        months: "%d Monaten",
        
        year: "einem Jahr",
        
        years: "%d Jahren"
        
        }
    };

    $.timeago.settings.strings = this.translation[this.currentLanguage];
  }

  init(index, element) {
    this.$(element).timeago();
  }
}